import currency from 'currency.js';
import { arrToObj } from 'utils/generic';

export function rowToAccount(row) {
  return {
    [row.id]: {
      number: row.number,
      description: row.description,
      groupId: row.groupId,
      periods: arrToObj(
        Object.keys(row)
          .filter((k) => k.startsWith('unadjusted-'))
          .map((k) => ({ [k.split('-')[1]]: { unadjusted: currency(row[k]) } }))
          .concat(
            Object.keys(row)
              .filter((k) => k.startsWith('adjusted-'))
              .map((k) => ({ [k.split('-')[1]]: { adjusted: currency(0) } }))
          )
      ),
    },
  };
}

export function rowToKpiGroup(row) {
  return {
    [row.id]: {
      name: row.name,
      childrenIds: row.childrenIds,
      expanded: row.expanded,
    },
  };
}
